module.exports = __webpack_public_path__ + "static/media/event.8c11415a.png";